import { ds } from "js/core/models/dataService";
import { _, $, Backbone } from "js/vendor";
import { isDevelopment, isPPTAddin } from "js/config";
import { app } from "js/namespaces";
import { DirectionType, SlideLockType } from "common/constants";
import { ThemePanel } from "js/editor/editorPanels/colorsPanel";
import { ExportToPPT } from "js/exporter/exportToPPT";
import { UIController } from "js/editor/dialogs/UIController";
import { controls } from "js/editor/ui";
import { getEditorDebugMenu } from "js/editor/editorDebugMenu";
import { handleEditSharedSlide } from "js/editor/editShareSlide";
import { getSlideMenu } from "js/editor/editorMenu";
import { getPresentationMenu } from "js/editor/presentationMenu";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { AddSlideContainer } from "js/react/views/AddSlide";
import { UpdateTemplateVersionDialog } from "./dialogs/UpdateTemplateVersionDialog";
import renderReactRoot, { renderReactRootJSX } from "js/react/renderReactRoot";
import React from "reactn";
import { Tooltip } from "@material-ui/core";
import { Gap10 } from "js/react/components/Gap";
import { SlideAdvanceOptionsPopup } from "js/react/views/SlideAdvanceOptionsPopup/SlideAdvanceOptionsPopup";

const animationIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="white" height="24" viewBox="0 0 24 24" width="24">
    <path id="arrow1" d="M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"/>
    <path id="arrow2" d="M0 0h24v24H0z" fill="none"/>
</svg>`;

const elementsIcon = `<svg width="31" height="24" viewBox="0 0 31 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="3.5" width="30" height="16" stroke="white"/>
<path d="M9.17 11.52L8.94 12.32H10.61L10.38 11.52C10.2733 11.1733 10.17 10.8167 10.07 10.45C9.97667 10.0833 9.88333 9.72 9.79 9.36H9.75C9.65667 9.72667 9.56333 10.0933 9.47 10.46C9.37667 10.82 9.27667 11.1733 9.17 11.52ZM6.98 15L9.11 8.46H10.47L12.6 15H11.38L10.87 13.23H8.67L8.16 15H6.98ZM13.4062 15V8.46H15.4962C15.8362 8.46 16.1462 8.49 16.4262 8.55C16.7128 8.60333 16.9595 8.69333 17.1662 8.82C17.3795 8.94 17.5428 9.10333 17.6562 9.31C17.7762 9.51667 17.8362 9.77 17.8362 10.07C17.8362 10.3833 17.7562 10.6733 17.5962 10.94C17.4362 11.2067 17.2128 11.39 16.9262 11.49V11.53C17.2862 11.61 17.5828 11.78 17.8162 12.04C18.0562 12.2933 18.1762 12.64 18.1762 13.08C18.1762 13.4067 18.1128 13.69 17.9862 13.93C17.8595 14.17 17.6828 14.37 17.4562 14.53C17.2362 14.69 16.9728 14.81 16.6662 14.89C16.3595 14.9633 16.0262 15 15.6662 15H13.4062ZM14.5662 11.16H15.3962C15.8562 11.16 16.1862 11.0767 16.3862 10.91C16.5928 10.7433 16.6962 10.52 16.6962 10.24C16.6962 9.92 16.5895 9.69333 16.3762 9.56C16.1628 9.42667 15.8428 9.36 15.4162 9.36H14.5662V11.16ZM14.5662 14.1H15.5462C16.0262 14.1 16.3962 14.0133 16.6562 13.84C16.9162 13.66 17.0462 13.3867 17.0462 13.02C17.0462 12.6733 16.9195 12.4233 16.6662 12.27C16.4128 12.11 16.0395 12.03 15.5462 12.03H14.5662V14.1ZM21.983 15.12C21.5696 15.12 21.183 15.0467 20.823 14.9C20.463 14.7533 20.1496 14.5367 19.883 14.25C19.623 13.9633 19.4163 13.61 19.263 13.19C19.1096 12.77 19.033 12.29 19.033 11.75C19.033 11.2167 19.1096 10.74 19.263 10.32C19.423 9.89333 19.6363 9.53333 19.903 9.24C20.1763 8.94667 20.493 8.72333 20.853 8.57C21.2196 8.41667 21.6096 8.34 22.023 8.34C22.4363 8.34 22.803 8.42333 23.123 8.59C23.443 8.75667 23.7063 8.95 23.913 9.17L23.293 9.92C23.1196 9.74667 22.933 9.61 22.733 9.51C22.533 9.40333 22.3063 9.35 22.053 9.35C21.7863 9.35 21.5396 9.40667 21.313 9.52C21.093 9.62667 20.8996 9.78333 20.733 9.99C20.573 10.19 20.4463 10.4367 20.353 10.73C20.2663 11.0233 20.223 11.3533 20.223 11.72C20.223 12.4667 20.383 13.0533 20.703 13.48C21.0296 13.9 21.4696 14.11 22.023 14.11C22.3163 14.11 22.5763 14.05 22.803 13.93C23.0296 13.8033 23.2363 13.64 23.423 13.44L24.043 14.17C23.7763 14.4767 23.4696 14.7133 23.123 14.88C22.783 15.04 22.403 15.12 21.983 15.12Z" fill="white"/>
</svg>
`;

const EditorMenuBar = Backbone.View.extend({

    className: "editor_menu_bar",

    events: {
        "click .presentation_menu": "showPresentationMenu",
        "click #organize": "toggleSlideGrid",
        "click #theme": "showThemePanel",
        "click #edit_theme": "showEditThemeDialog",
        "click #revisions": "showRevisionHistory",
        "click #notes": "toggleNotes",
        "click #animation_panel": "toggleAnimationPanel",
        "click #audio_panel": "toggleAudioPanel",
        "click #export-to-ppt": "exportToPPT",
        "click #elements": "showElementsPanel",
        "click #layout": "showLayoutPanel",
        "click #slide-options": "showSlideOptionsMenu",
        "click #debug": "showDebugMenu",
    },

    initialize({
        editor,
        showAnimationButtons = true,
        showSpeakerNotesButton = true,
        slideMenuOptions = {}
    }) {
        this.editor = editor;
        this.showAnimationButtons = showAnimationButtons;
        this.showSpeakerNotesButton = showSpeakerNotesButton;
        this.slideMenuOptions = slideMenuOptions;
    },

    remove: function() {
        this.unmount && this.unmount();
        this.unmountSlideAdvanceOptionsPopup && this.unmountSlideAdvanceOptionsPopup();
    },

    renderSlideInfo: function(slide) {
        if (this.unmountInfo) {
            this.unmountInfo();
            this.unmountInfo = null;
        }
        this.$infoButton.empty();

        let libraryItem = slide.getLibraryItem();
        if (libraryItem) {
            const {
                name,
                description,
            } = libraryItem.attributes;
            this.unmountInfo = this.createTooltip(this.$infoButton[0], "info", "Slide Info", {
                content: (
                    <div>
                        <div
                            style={{
                                fontWeight: 600,
                                fontSize: 12,
                            }}
                        >{name}</div>
                        <Gap10 />
                        <div>{description || "No description available"}</div>
                    </div>
                ),
                placement: "left",
            });
        } else if (!this.showSpeakerNotesButton) {
            this.$infoButtonDivider.hide();
        }
    },

    render: function() {
        if (!ds.selection.presentation.get("isSlideEditor")) {
            let $presentationMenu = this.$el.addEl($.div("presentation_menu"));

            if (!ds.selection.presentation.get("isSlideEditor")) {
                $presentationMenu.append($.icon("menu"));
            }
        }

        let $slideMenu = this.$el.addEl($.div("slide_menu"));

        $slideMenu.append(this.createMenuButton("theme", "", "Colors").addClass("colors"));

        $slideMenu.append(this.createMenuButton("layout", "view_compact", "Layout"));
        $slideMenu.append(this.createMenuButton("elements", elementsIcon, "Add Element"));

        if (this.showAnimationButtons) {
            $slideMenu.append($.div("divider"));
            $slideMenu.append(this.createMenuButton("animation_panel", animationIcon, "Animation").addClass("animation-icon"));
            $slideMenu.append(this.createMenuButton("audio_panel", "mic", "Audio").addClass("animation-icon"));
            const $slideAdvanceOptionsPopupContainer = $.div();
            $slideMenu.append($slideAdvanceOptionsPopupContainer);
            this.unmountSlideAdvanceOptionsPopup = renderReactRoot(SlideAdvanceOptionsPopup, { editor: this.editor }, $slideAdvanceOptionsPopupContainer[0]);
        }

        $slideMenu.append($.div("divider"));
        $slideMenu.append(this.createMenuButton("slide-options", "more_horiz", "More"));

        $slideMenu.append($.div("spacer"));

        if (isDevelopment && !isPPTAddin) {
            $slideMenu.append($.div("divider"));
            $slideMenu.append(this.createMenuButton("export-to-ppt", "cloud_download", "Export To PPT"));
            $slideMenu.append(this.createMenuButton("debug", "bug_report", "Debug"));
        }

        this.$infoButtonDivider = $.div("divider");
        this.$infoButton = $.div().attr("id", "slide-info");
        $slideMenu.append(this.$infoButtonDivider);
        $slideMenu.append(this.$infoButton);

        if (this.showSpeakerNotesButton) {
            $slideMenu.append(this.createMenuButton("notes", "chrome_reader_mode", "Notes"));
        }

        this.listenTo(app.mainView.editorView.lockModel, "change:lockState", model => {
            if (model.attributes.lockState[SlideLockType.COLLABORATION]) {
                this.$el.find(".menu_button").not("#organize_slides, .back_button").addClass("disabled");
                $("[collab-lock]").addClass("disabled");
                return;
            } else {
                this.$el.find(".menu_button").not("#organize_slides, .back_button").removeClass("disabled");
                $("[collab-lock]").removeClass("disabled");
            }

            if (model.attributes.lockState[SlideLockType.ORG] ||
                model.attributes.lockState[SlideLockType.TEAM_MEMBER]) {
                this.$el.find(".menu_button").not("#organize_slides, #notes, #slide-info .menu_button, #slide-options, .back_button").addClass("disabled-with-pointer-events");
                return;
            } else {
                this.$el.find(".menu_button").not("#organize_slides, #notes, #slide-info .menu_button, #slide-options, .back_button").removeClass("disabled-with-pointer-events");
            }

            if (model.attributes.lockState[SlideLockType.OBSOLETE_TEMPLATE]) {
                this.$el.find(".menu_button").not("#organize_slides, .back_button, #slide-options").addClass("disabled-with-pointer-events");
            } else {
                this.$el.find(".menu_button").not("#organize_slides, .back_button, #slide-options").removeClass("disabled-with-pointer-events");
            }
        });

        return this;
    },

    checkIfTemplateIsObsoleteAndDialogShouldRender: function() {
        const requiresTemplateUpdate = app.currentCanvas.slideTemplate.constructor.updateTemplateId != null;
        const isTemplateObsolete = (app.currentCanvas.slideTemplate && requiresTemplateUpdate);
        return isTemplateObsolete && this.editor.lockModel.checkIfOnlyLockActive(SlideLockType.OBSOLETE_TEMPLATE);
    },

    renderUpgradeTemplateDialog: function() {
        ShowDialog(UpdateTemplateVersionDialog, {
            canvas: app.currentCanvas,
            onUpdateTemplate: () => {
                app.currentCanvas.unlockSlide(SlideLockType.OBSOLETE_TEMPLATE);
                this.editor.$lockedSlideShield.remove();
                this.editor.updateCurrentCanvasUI();
            }
        });
    },

    exportToPPT: function(event) {
        const exporter = new ExportToPPT();
        exporter.export({ slideCanvases: [app.currentCanvas], debug: event.shiftKey });
    },

    createMenuButton: function(id, icon, label) {
        const $button = $.div("menu_button").attr("id", id);
        $button.append($.icon(icon));
        $button.append($.label(label));
        return $button;
    },

    createTooltip: (container, icon, label, tooltipProps = {}) => {
        tooltipProps = {
            content: (
                <span>Empty</span>
            ),
            classes: "popper-white rounded-5",
            placement: "top",
            ...tooltipProps,
        };

        const {
            content,
            classes,
            placement,
        } = tooltipProps;

        const tooltip = (
            <Tooltip
                title={(
                    <div style={{ padding: 10 }}>
                        {content}
                    </div>
                )}
                classes={{ popper: classes }}
                placement={placement}
                arrow
                interactive
            >
                <div className="menu_button">
                    <i className="micon">{icon}</i>
                    <label>{label}</label>
                </div>
            </Tooltip>
        );

        return renderReactRootJSX(tooltip, container);
    },

    showRevisionHistory: function() {
        UIController.showVersionHistory();
    },

    showThemePanel: function() {
        if (app.mainView.editorView.checkIfSharedSlideIsReadOnly()) {
            handleEditSharedSlide();
            return;
        }

        if (this.checkIfTemplateIsObsoleteAndDialogShouldRender()) {
            this.renderUpgradeTemplateDialog();
            return;
        }

        app.mainView.editorView.showSideBar(new ThemePanel(), true, DirectionType.LEFT);
    },

    showEditThemeDialog: function() {
        ds.selection.element = null;
        app.dialogManager.showEditThemeDialog(app.currentTheme);
    },

    showElementsPanel: function() {
        if (app.mainView.editorView.checkIfSharedSlideIsReadOnly()) {
            handleEditSharedSlide();
            return;
        }
        if (this.checkIfTemplateIsObsoleteAndDialogShouldRender()) {
            this.renderUpgradeTemplateDialog();
            return;
        }
        app.mainView.editorView.showAddAnnotation();
    },

    showLayoutPanel: function() {
        if (app.mainView.editorView.checkIfSharedSlideIsReadOnly()) {
            handleEditSharedSlide();
            return;
        }
        if (this.checkIfTemplateIsObsoleteAndDialogShouldRender()) {
            this.renderUpgradeTemplateDialog();
            return;
        }
        app.mainView.editorView.showAddElement();
    },

    togglePresentationSettings: function() {
        if (this.checkIfTemplateIsObsoleteAndDialogShouldRender()) {
            this.renderUpgradeTemplateDialog();
            return;
        }
        if (app.mainView.editorView.isPresentationSettingsOpen) {
            app.mainView.editorView.hidePresentationSettings();
        } else {
            app.mainView.editorView.showPresentationSettings();
        }
    },

    toggleSlideGrid: function() {
        if (app.mainView.editorView.slideGrid) {
            app.mainView.editorView.hideSlideGrid();
        } else {
            app.mainView.editorView.showSlideGrid();
        }
    },

    showTemplatePanel: function() {
        ShowDialog(AddSlideContainer);
    },

    toggleNotes: function() {
        if (this.checkIfTemplateIsObsoleteAndDialogShouldRender()) {
            this.renderUpgradeTemplateDialog();
            return;
        }
        this.editor.toggleSpeakerNotes();
    },

    toggleAnimationDialog: function() {
        if (this.checkIfTemplateIsObsoleteAndDialogShouldRender()) {
            this.renderUpgradeTemplateDialog();
            return;
        }
        this.editor.toggleAnimationDialog();
    },

    toggleAnimationPanel: function() {
        if (this.checkIfTemplateIsObsoleteAndDialogShouldRender()) {
            this.renderUpgradeTemplateDialog();
            return;
        }
        this.editor.toggleAnimationPanel();
    },

    toggleAudioPanel: function() {
        if (this.checkIfTemplateIsObsoleteAndDialogShouldRender()) {
            this.renderUpgradeTemplateDialog();
            return;
        }
        this.editor.toggleAudioPanel();
    },

    showPresentationMenu: function() {
        controls._createMenu($(".presentation_menu"), getPresentationMenu());
    },

    showSlideOptionsMenu: function() {
        controls._createMenu($("#slide-options"), getSlideMenu({ ...this.slideMenuOptions, source: "editor:menuBar" }));
    },

    showDebugMenu: function() {
        if (this.checkIfTemplateIsObsoleteAndDialogShouldRender()) {
            this.renderUpgradeTemplateDialog();
            return;
        }
        controls._createMenu($("#debug"), getEditorDebugMenu());
    }

});

export { EditorMenuBar };
